/** Unified input state — game code reads only this (docs/06). */
export interface InputState {
  /** Movement vector, -1..1 (normalized) */
  moveX: number;
  moveY: number;
  /** Aim direction (unit vector) — when hasAim is false the player fires along facing */
  aimX: number;
  aimY: number;
  hasAim: boolean;
  fire: boolean;
  supershot: boolean;
  /** Edge-triggered: pressed this frame */
  dashPressed: boolean;
  /** Confirm HELD (A / Space down) — drives hold-to-buy (docs/12 N1) */
  confirmHeld: boolean;
  /** Side dodges (Q/E or LB/RB) — edge-triggered */
  dodgeLeftPressed: boolean;
  dodgeRightPressed: boolean;
  /** Secondary action (R / B) — shop reroll, future bomb trigger */
  altPressed: boolean;
  /** Scrap action (X / Ⓧ) — trash the focused hangar weapon */
  trashPressed: boolean;
  /** Info toggle (Y / I) — weapon details for the focused hangar item */
  infoPressed: boolean;
  slowHeld: boolean;
  pausePressed: boolean;
}

export type InputDevice = 'keyboard' | 'gamepad' | 'touch';

export function emptyInput(): InputState {
  return {
    moveX: 0,
    moveY: 0,
    aimX: 1,
    aimY: 0,
    hasAim: false,
    fire: false,
    supershot: false,
    dashPressed: false,
    confirmHeld: false,
    dodgeLeftPressed: false,
    dodgeRightPressed: false,
    altPressed: false,
    trashPressed: false,
    infoPressed: false,
    slowHeld: false,
    pausePressed: false,
  };
}
